function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Acesso aos M\xF3dulos");

var SvgModuleAccess = function SvgModuleAccess(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, React.createElement("path", {
    d: "M88.29,27.36H7.71A2.71,2.71,0,0,0,5,30.07V65.93a2.71,2.71,0,0,0,2.71,2.71H88.29A2.71,2.71,0,0,0,91,65.93V30.07A2.71,2.71,0,0,0,88.29,27.36ZM48,33.53a6.24,6.24,0,1,1-6.24,6.23A6.24,6.24,0,0,1,48,33.53ZM59.41,62H36.59a2.74,2.74,0,0,1,0-5.47H59.41a2.74,2.74,0,0,1,0,5.47Z",
    style: {
      fill: "#ccc"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgModuleAccess, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/MODULE-ACCESS.32db2854.svg";
export { ForwardRef as ReactComponent };